import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/terms-conditions/new/loading';

export const Route = createFileRoute('/_private/settings/terms-conditions/new')({
  component: Loading,
});
